export default "__VITE_ASSET__COvjW59b__"